import dayjs from 'dayjs';
import { useCallback, useMemo } from 'react';
import useSWR from 'swr';
import urlcat from 'urlcat';
import { apiUrls } from '../utils/apiUtils';
import { fetcher } from '../utils/fetcher';
import { notifySpendingThisMonth as notifySpendingThisMonthBridge } from '../utils/webViewBridge';
import { TransactionSummarizeApiResponse } from './useDashboardTransactionSumarize';


/**
 * Hook that provides a function to notify total expenses for this month
 * Gets current month expense data from transaction summarize
 */
export const useNotifySpendingThisMonth = () => {
  const params = {
    cashType: 'expense',
    groupBy: 'categoryGroup',
    assets: 'finance',
    dateType: 'month',
    from: dayjs().startOf('month').toISOString(),
    to: dayjs().endOf('month').toISOString(),
  };
  const requestUrl = urlcat(apiUrls.transactionSummarize(), params);
  const { data: apiData, isLoading, error, mutate } = useSWR<TransactionSummarizeApiResponse>(
    requestUrl,
    fetcher,
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  );

  // Get current month's total expenses
  const currentMonthExpenses = useMemo(() => {
    if (!isLoading && !error) {
      return apiData?.data?.netFlow
        .find(item => item.transactionDate === dayjs().format('YYYY-MM'))?.expense || 0;
    }

    return 0;
  }, [apiData, isLoading, error]);

  const notifySpendingThisMonth = useCallback(async () => {
    await mutate();

    notifySpendingThisMonthBridge(currentMonthExpenses);
  }, [mutate, currentMonthExpenses]);

  return { notifySpendingThisMonth, currentMonthExpenses, isLoading, error };
};

export default useNotifySpendingThisMonth;
